// extracted by mini-css-extract-plugin
export default {"wrapper":"NewTask_wrapper__dNTGw","color__wrapper":"NewTask_color__wrapper__Y53OQ","title":"NewTask_title__BtAcp","desc":"NewTask_desc__K0nOY"};